import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ErrorResponse } from '@/common/types/errorResponse'
import { ExternalSupportTicketValidationSchema } from '@/features/support/external/schemas/create.schema'
import { useMutation } from '@tanstack/react-query'
import { AxiosResponse } from 'axios'

interface UseCreateExternalSupportTicketProps {
  creator_id?: string
  onSuccess: (response: AxiosResponse) => void
  onError: (error: ErrorResponse) => void
}

export const useCreateExternalSupportTicket = ({ creator_id, onSuccess, onError }: UseCreateExternalSupportTicketProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['createExternalSupportTicket'],
    mutationFn: async (form: ExternalSupportTicketValidationSchema) => {
      const payload = {
        reason_id: form.reason.value,
        subject_line: form.subject_line,
        first_message_attributes: {
          creator_id,
          creator_type: 'Client::User',
          content: form.content,
          documents_attachments_attributes: form.documents?.length
            ? form.documents.map((document) => ({ blob_id: document.id }))
            : undefined,
        },
        branch_id: form?.branch_type?.value === 'Client::CompanyBranch' ? form?.branch?.value : form?.company?.value,
        branch_type: form?.branch_type?.value,
      }

      return privateAxios.post('/support/tickets', { support_ticket: payload })
    },
    onSuccess,
    onError,
  })
}
